import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Box from "@mui/material/Box";
import React, { useContext } from "react";

import MenuButton from "@/components/MenuButton.tsx";
import { WorkspaceContext } from "@/models/StateProviders/workspaceProvider.tsx";

export default function WorkspaceDropdown() {
  const { currentWorkspaceId, workspaces } = useContext(WorkspaceContext);
  const activeWorkspace = workspaces?.find((ws) => ws.id === currentWorkspaceId);
  const [isDropdownOpen, setIsDropdownOpen] = React.useState(false);

  if (!workspaces || workspaces?.length === 0 || !activeWorkspace) {
    return <div>loading...</div>;
  }

  return (
    <Box sx={{ display: "flex", width: "100%", gap: 1 }}>
      <MenuButton
        position="left"
        openState={(value) => setIsDropdownOpen(() => value)}
        element={
          <Box
            sx={{
              cursor: "pointer",
              p: 1,
              borderRadius: 1,
              "&:hover": { background: "var(--color-zinc-800)" },
              display: "flex",
              alignItems: "center",
              gap: 1,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              color: "#fff",
              fontSize: "1rem",
            }}
          >
            <Box
              sx={{
                textTransform: "uppercase",
                border: "1px solid",
                display: "flex",
                p: 0.25,
                borderRadius: 0.5,
              }}
            >
              {!isDropdownOpen ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />}
            </Box>
            <Box
              sx={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                pr: 1,
              }}
            >
              {activeWorkspace.name}
            </Box>
          </Box>
        }
      >
        <Box sx={{ py: 1 }}>
          {workspaces.map((ws) => (
            <Box
              key={ws.id}
              component="a"
              href={currentWorkspaceId === ws.id ? undefined : `/workspaces/${ws.id}/drivers`}
              sx={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                gap: 1,
                py: 1,
                px: 2,
                textDecoration: "none",
                ...(currentWorkspaceId === ws.id
                  ? { color: "var(--color-zinc-400)" }
                  : { color: "#fff", "&:hover": { bgcolor: "var(--color-zinc-700)" } }),
              }}
            >
              <Box
                component="span"
                sx={{
                  textTransform: "uppercase",
                  border: "1px solid",
                  display: "flex",
                  py: 0.25,
                  px: 1,
                  width: "30px",
                  textAlign: "center",
                  borderRadius: 0.5,
                  borderColor: currentWorkspaceId === ws.id ? "var(--color-zinc-400)" : "#fff",
                }}
              >
                {ws.name[0]}
              </Box>
              <Box
                component="span"
                sx={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {ws.name}
              </Box>
            </Box>
          ))}
        </Box>
      </MenuButton>
    </Box>
  );
}
